import type { IClassroomStudentRepository } from './interfaces/IClassroomStudentRepository'
import type { ClassroomStudent } from '@/types'
import { getDocuments, where } from '@/services/firestore'

export class FirestoreClassroomStudentRepository implements IClassroomStudentRepository {
  async getByStudentId(studentId: string): Promise<ClassroomStudent[]> {
    return getDocuments<ClassroomStudent>('classroom_students', [
      where('student_id', '==', studentId),
    ])
  }
}
